import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Menu, MenuItem, } from "@mui/material";
import { api_urls } from "../../utils/api-urls/index.js";
import * as CategoryActions from '../../redux/actions/categoryAction.js';
import MainDatatable from "../../components/common/MainDatatable.jsx";
import logo_icon from '../../assets/images/Logo/Bharat-Darshan-Logo.png';
import { DeleteSvg, EditSvg, FilterSvg, SwitchOffSvg, SwitchOnSvg } from "../../assets/svg/index.js";

const Category = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { categoryData } = useSelector(state => state.categoryReducer);

    //! Handle Filter 
    const [filterText, setfilterText] = useState('');
    const uniqueRedirectPage = Array.from(new Set(categoryData.map(item => item?.redirect_page)));
    const [anchorEl, setAnchorEl] = useState(null);
    const handleOpenFilterDropDown = (event) => { setAnchorEl(event.currentTarget) };
    const handleCloseFilterDropDown = () => { setAnchorEl(null) };

    const handleFilter = (data) => {
        setfilterText(data)
        handleCloseFilterDropDown()
    };

    let filteredData;
    if (filterText.toLowerCase() === "all") {
        filteredData = categoryData;
    } else {
        filteredData = categoryData && categoryData.filter(item =>
            Object.values(item).some(value =>
                value && value?.toString().toLowerCase().includes(filterText?.toLowerCase())
            )
        );
    };

    //* DataTable Columns
    const columns = [
        { name: 'S.No.', selector: row => filteredData.length - filteredData.indexOf(row), style: { backGroundColor: "#000", paddingLeft: "20px" } },
        { name: 'Category Name', selector: row => row?.category_name },
        { name: <div onClick={handleOpenFilterDropDown} style={{ cursor: "pointer", display: "flex", alignItems: "center" }}><span>Redirect Page</span>  <FilterSvg h={'16'} /></div>, selector: row => row?.redirect_page },
        { name: 'Image', cell: row => <img src={row?.image ? api_urls + row?.image : logo_icon} alt="Profile" style={{ width: '50px', height: '50px', borderRadius: '50%' }} /> },
        { name: 'Status', selector: row => <div onClick={() => dispatch(CategoryActions?.changeCategoryStatus({ categoryId: row?._id }))} style={{ cursor: "pointer" }}>{row?.status == 'Active' ? <SwitchOnSvg /> : <SwitchOffSvg />}</div> },
        {
            name: 'Action',
            cell: row => <div style={{ display: "flex", gap: "20px", alignItems: "center" }} >
                <div onClick={() => navigate('/category/edit-category', { state: { stateData: row } })} style={{ cursor: "pointer" }}><EditSvg /></div>
                <div onClick={() => dispatch(CategoryActions.deleteCategory({ categoryId: row?._id }))} style={{ cursor: "pointer" }}><DeleteSvg /></div>
            </div >,
            width: "180px"
        },
    ];

    useEffect(() => {
        //! Dispatching API for Getting Category
        dispatch(CategoryActions.getCategory())
    }, []);

    return (
        <>
            <MainDatatable data={filteredData} columns={columns} title={'Category'} url={'/category/add-category'} />

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseFilterDropDown} >
                <MenuItem style={{ width: "100px" }} onClick={() => handleFilter('all')}>All</MenuItem>
                {uniqueRedirectPage?.map((value, index) => (
                    <MenuItem key={index} style={{ width: "100px" }} onClick={() => handleFilter(value)}>{value}</MenuItem>
                ))}
            </Menu>
        </ >
    );
}

export default Category;